import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import AdditionalProductsPage from './AdditionalProductsPage';
import { dataCaptureSelectors, saveAdditionalProductsForm } from '../../store/dataCapture';
import { ADDITIONAL_PRODUCT } from '../../utils/constants';
import { selectors as caseSelector } from '../../infrastructure/cases';

const AdditionalProductsSection = ({
  saveAdditionalProductsForm,
  getBusinessData,
  isSoleTrader
}) => {
  const [selectedProducts, setSelectedProducts] = useState(
    getBusinessData ? Object.values(getBusinessData.additionalProductsInterestedField) : []
  );

  return (
    <AdditionalProductsPage
      saveAdditionalProductsForm={values => {
        saveAdditionalProductsForm(
          { additionalProductsInterestedField: Object.values(values) },
          isSoleTrader
        );
      }}
      selectedProducts={selectedProducts}
      setSelectedProducts={products => setSelectedProducts(products)}
    />
  );
};

AdditionalProductsSection.propTypes = {
  saveAdditionalProductsForm: PropTypes.func.isRequired
};

const actionCreators = {
  saveAdditionalProductsForm
};

const mapStateToProps = state => ({
  getBusinessData: dataCaptureSelectors.getBusinessData(state, ADDITIONAL_PRODUCT),
  isSoleTrader: caseSelector.isSoleTrader(state)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalProductsSection);
